import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './Header.js';
import LandingPage from './LandingPage.js';
import TermsConditions from './TermsConditions.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import Contact from './Contact.js';

function App() {
  return (
    <Router>
      <div>
        <Header/>
        <Routes>
          <Route path="/" element={<LandingPage/>} />
          <Route path="/terms" element={<TermsConditions/>} />
          <Route path="/privacy" element={<PrivacyPolicy/>} />
          <Route path="/contact" element={<Contact/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
